/**
 * Общая статистика
 * @return Promise
 */
const statList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/general/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Общая статистика. Кол-во строк.
 * @return Promise
 */
const statListCnt = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/general/getListCnt",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Общая статистика. Данные для графика
 * @return Promise
 */
const statChartData = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/statistics/general/getChartData",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { statList, statListCnt, statChartData };
